import { FeaturedMessageItem } from "./components/FeaturedMessage.tsx";
import { FeaturedMessagesAllForNow } from "./components/FeaturedMessageAllForNow.tsx";
import styles from "./FeaturedMessages.module.css";
import {
  type LiveFeedEntry,
  useLiveFeedEntries,
} from "./hooks/use-live-feed-entries.ts";

export const FeaturedMessages = () => {
  const { entries } = useLiveFeedEntries();

  const featuredMessages = entries.filter(isFeaturedMessage);

  if (featuredMessages.length === 0) {
    return null;
  }

  return (
    <div className={styles["scroll-container"]}>
      {featuredMessages.map((entry) => (
        <FeaturedMessageItem message={entry} key={entry.id} />
      ))}
      <FeaturedMessagesAllForNow />
    </div>
  );
};

function isFeaturedMessage(
  entry: LiveFeedEntry,
): entry is LiveFeedEntry & { kind: "FEATURED_MESSAGE" } {
  return entry.kind === "FEATURED_MESSAGE";
}
